import { ClientRepository } from "../../../domain/repositories/client.repository";
import { GetClientAllByIdUseCase } from "../../../domain/usecases/client/get-client-all-by-id.usecase";
import { GetClientAllByKeywordUseCase } from "../../../domain/usecases/client/get-client-all-by-keyword.usecase";
import { GetClientAllUseCase } from "../../../domain/usecases/client/get-client-all.usecase";
import { InsertClientUseCase } from "../../../domain/usecases/client/insert-client.usecase";
import { StatusClientUseCase } from "../../../domain/usecases/client/status-client.usecase";
import { UpdateClientUseCase } from "../../../domain/usecases/client/update-client.usecase";

const getClientAllUseCaseFactory = 
(ClientRepo: ClientRepository) => new GetClientAllUseCase(ClientRepo);
export const  GetClientAllUseCaseProvider= {
    provide: GetClientAllUseCase,
    useFactory: getClientAllUseCaseFactory,
    deps: [ClientRepository],
};

const getClientAllByKeywordUseCaseFactory = 
(ClientRepo: ClientRepository) => new GetClientAllByKeywordUseCase(ClientRepo);
export const  GetClientKeywordAllStatesUseCaseProvider= {
    provide: GetClientAllByKeywordUseCase,
    useFactory: getClientAllByKeywordUseCaseFactory,
    deps: [ClientRepository],
};

const getClientByIdUseCaseFactory = 
(ClientRepo: ClientRepository) => new GetClientAllByIdUseCase(ClientRepo);
export const  GetClientByIdUseCaseProvider= {
    provide: GetClientAllByIdUseCase,
    useFactory: getClientByIdUseCaseFactory,
    deps: [ClientRepository],
};

const statusClientUseCaseFactory = 
(ClientRepo: ClientRepository) => new StatusClientUseCase(ClientRepo);
export const  StatusClientUseCaseProvider= {
    provide: StatusClientUseCase,
    useFactory: statusClientUseCaseFactory,
    deps: [ClientRepository],
};

const insertClientUseCaseFactory = 
(ClientRepo: ClientRepository) => new InsertClientUseCase(ClientRepo);
export const InsertClientUseCaseProvider = {
    provide: InsertClientUseCase,
    useFactory: insertClientUseCaseFactory,
    deps: [ClientRepository],
};

const updateClientUseCaseFactory = 
(ClientRepo: ClientRepository) => new UpdateClientUseCase(ClientRepo);
export const UpdateClientUseCaseProvider = {
    provide: UpdateClientUseCase,
    useFactory: updateClientUseCaseFactory,
    deps: [ClientRepository],
};

